import { connect } from 'react-redux';

const mapStateToProps = state => ({
  dropDownItems: state.mainreducer.dropDownItems,
});

export default MainLayout => connect(mapStateToProps, null)(MainLayout);
